<template>
  <main>
      <div>
        <h1>
          <span>Page Not Found</span>
        </h1>

        <p>
          <a class="text-white" @click="() => { goTo('home') }">Take me home <i class="material-icons">home</i></a>
          <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
          <a class="text-white" href="mailto:support@cellulant.io">Report issue <i class="material-icons">error_outline</i></a>
        </p>
      </div>
  </main>
</template>

<script>
  const enableLogging = !!(process.env.NODE_ENV !== 'production')

  export default {
    name: 'NotFoundComponent',
    mounted () {
      enableLogging && console.log('Route does not match any of the routes => ', this.$router)
    }
  }
</script>

<style lang="scss" scoped>
  @import "../styles/_colors";

  main {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 100%;
    height: 100vh;
    overflow: hidden;

    background-image: linear-gradient(to bottom right, $tingg-primary-red, $tingg-purple);

    div {
      color: #ffffff;
      text-align: center;

      p {
        a {
          display: inline-flex;
          text-decoration: none;

          i.material-icons {
            margin-left: 8px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/NotFoundComponent.vue